import React, { useRef, useEffect } from "react";

/**
 * Inline editable text — contentEditable wrapper.
 * Sadece blur'da state gunceller, re-render'da icerik ezilmez.
 */
const EditableText = React.memo(function EditableText({
  value,
  onUpdate,
  className = "",
  style,
  tag: Tag = "div",
  placeholder = "",
}) {
  const ref = useRef(null);
  const internalValue = useRef(value);

  // Sadece disaridan gelen degisiklikleri yansit (ilk render + programmatic update)
  useEffect(() => {
    if (ref.current && value !== internalValue.current) {
      ref.current.innerText = value;
      internalValue.current = value;
    }
  }, [value]);

  // Ilk render
  useEffect(() => {
    if (ref.current) {
      ref.current.innerText = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Tag
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      data-placeholder={placeholder}
      onBlur={() => {
        const text = ref.current?.innerText || "";
        internalValue.current = text;
        onUpdate?.(text);
      }}
      className={`outline-none hover:bg-primary/5 focus:bg-primary/10 focus:ring-1 focus:ring-primary/30 rounded px-0.5 -mx-0.5 transition-colors cursor-text whitespace-pre-wrap empty:before:content-[attr(data-placeholder)] empty:before:text-gray-300 ${className}`}
      style={style}
    />
  );
});

export default EditableText;
